import BrowserUtil from '@/platform/oss/browserUtil'
import { removeCloudProjectIndexItem } from '@/features/project-cloud/ossList'

/**
 * 删除当前账号 OSS 上的整个工程目录，并从 `projectIndex.json` 去掉对应项。
 * @param projectKey 工程 guid
 */
export async function deleteCloudProject(projectKey: string): Promise<void> {
  const guid = projectKey.trim()
  if (!guid) {
    throw new Error('工程 guid 为空，无法删除')
  }
  const oss = BrowserUtil.getInstance()
  if (!oss.isConfigured()) {
    throw new Error('未配置云端存储，无法删除工程')
  }
  await oss.deleteFolder(guid)
  await removeCloudProjectIndexItem(guid)
}
